interface ImageItem {
  id: string;
  src: string;
  title?: string;
}

interface ImageGalleryProps {
  images: ImageItem[];
  onImageClick?: (id: string) => void;
}

export function ImageGallery({
  images,
  onImageClick,
}: Readonly<ImageGalleryProps>) {
  return (
    <div className='relative w-full overflow-x-auto pb-2'>
      <div className='flex justify-between gap-4 md:gap-6 min-w-max'>
        {images.map((image) => (
          <button
            key={image.id}
            onClick={() => onImageClick?.(image.id)}
            className='flex-shrink-0 w-40 md:w-[14vw] h-auto rounded-2xl overflow-hidden relative cursor-pointer shadow-md transition-transform'
          >
            <img
              src={image.src}
              alt={image.title ?? ''}
              className='w-full h-full object-cover'
            />

            <div className='absolute bottom-0 left-0 w-full h-1/5 bg-gradient-to-t from-black/60 to-transparent pointer-events-none' />

            {image.title && (
              <div className='absolute bottom-2 left-2 text-white text-sm font-semibold px-2 py-1'>
                {image.title}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
